<template>
  <div>
    <Mian
      ref="main"
      :loading="loading"
      :tableData="tableData"
      @reload="getData"
    >
    </Mian>
  </div>
</template>
<script>
import Mian from './main'
export default {
  components: { Mian },
  props: {
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .pendingOrderInspectionDocListApi({
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
  },
}
</script>
